import { getPackCodeReport } from '../../services/api/packCodeReportApi';
import {
    SET_PACK_CODE_FILTERS,
    GET_PACK_CODE_REPORT,
    CLEAR_PACK_CODE_REPORT,
} from './actionTypes';
import { hideLoading, showLoading } from './loadingActions';
import { notifyError } from './notificationActions';

export const setPackCodeFilters = (filters) => {
    return {
        type: SET_PACK_CODE_FILTERS,
        filters,
    };
};

export const getPackCodeReportAction = (reportData, totalCount) => {
    return {
        type: GET_PACK_CODE_REPORT,
        reportData,
        totalCount,
    };
};

export const clearPackCodeReport = () => {
    return {
        type: CLEAR_PACK_CODE_REPORT,
    };
};

export function fetchPackCodeReport(
    market,
    category,
    brand,
    fromDate,
    toDate,
    gigyaId = '',
    packCode = '',
    eventType = '',
    start = 0,
    limit = 10
) {
    return function (dispatch, getState) {
        return Promise.resolve()
            .then(() => dispatch(showLoading()))
            .then(() =>
                getPackCodeReport(
                    market,
                    category,
                    brand,
                    fromDate,
                    toDate,
                    gigyaId,
                    packCode,
                    eventType,
                    start,
                    limit
                )
            )
            .then((response) => response?.data)
            .then((data) =>
                dispatch(
                    getPackCodeReportAction(
                        data?.results || [],
                        data?.totalCount || 0
                    )
                )
            )
            .catch((error) =>
                dispatch(
                    notifyError('Error!', 'Unable to fetch pack code report')
                )
            )
            .finally(() => dispatch(hideLoading()));
    };
}
